import { CF_ACTIVE_SLIDER_DICTIONARY } from "../constants";
import { CfColSize } from "types/generic/types";
import { CfListProps, ModCfListProps, SLIDER_VALUES } from "../types";
import {
  convertCfAlignItemsProps,
  convertCfJustifyContentProps,
} from "utilities/cfPropTypes/cfFlex";
import { convertCfColSizeProps } from "utilities/cfPropTypes/cfColSize";
import List from "..";
import React from "react";

export const convertCfListProps = ({
  id,
  activeSlider,
  columnLayout,
  customClass,
  style,
  children,
}: CfListProps) => {
  const activeSliderValue: SLIDER_VALUES[] | undefined = activeSlider
    ? [CF_ACTIVE_SLIDER_DICTIONARY[activeSlider]]
    : undefined;

  return {
    id,
    activeSlider: activeSliderValue,
    customClass: customClass || "",
    children,
    ...convertCfColSizeProps(
      !columnLayout || Object.values(columnLayout).length === 0
        ? ({ default: "1" } as CfColSize)
        : (columnLayout as CfColSize),
    ),
    ...convertCfJustifyContentProps(style?.justifyContent),
    ...convertCfAlignItemsProps(style?.alignItems),
  };
};

const CfList = (props: CfListProps) => <List {...convertCfListProps(props)} />;

export default CfList;
